// extracted by mini-css-extract-plugin
export var articleBox = "PostsListing-module--article-box--2a52b";
export var articleList = "PostsListing-module--article-list--8f0cd";
export var featureImg = "PostsListing-module--featureImg--1910b";
export var meta = "PostsListing-module--meta--50dab";
export var pageview = "PostsListing-module--pageview--68a78";
export var right = "PostsListing-module--right--20409";